import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorPage from '@/views/pages/404Page';
import { GuardedPageRoute } from '../routeGuards';
import { BankManagementPage, CreateBankPage, EditBankPage } from '../lazyPages';

export const BankManagementRoutes = () => {
  const { t } = useTranslation();
  return (
    <Routes>
      <Route
        index
        element={
          <GuardedPageRoute pageName={t('BANK_MANAGEMENT.TITLE')}>
            <BankManagementPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="create"
        element={
          <GuardedPageRoute
            pageName={t('BANK_MANAGEMENT.CREATE_TITLE')}
            action="create"
          >
            <CreateBankPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="edit/:id"
        element={
          <GuardedPageRoute
            pageName={t('BANK_MANAGEMENT.EDIT_TITLE')}
            action="update"
          >
            <EditBankPage />
          </GuardedPageRoute>
        }
      />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};
